import React, { Component } from 'react';
import PT from 'prop-types';
import cIf from 'classnames';
import { MDCDrawer } from '@material/drawer';
import { MDCTopAppBar } from '@material/top-app-bar';
import { IconButton } from './iconbutton';


export class SideMenu extends Component {
    constructor(props) {
        super(props);
        this.mdDrawerRef = React.createRef();
        this.toggleMenuClick = this.toggleMenu.bind(this);
        this.mdDrawer = null;
    }

    componentDidMount() {
        this.mdDrawer = MDCDrawer.attachTo(this.mdDrawerRef.current);

        const topAppBar = MDCTopAppBar.attachTo(document.getElementById(this.props.appBarId));
        topAppBar.setScrollTarget(document.getElementById(this.props.mainContentId));
        topAppBar.listen('MDCTopAppBar:nav', () => {
            this.mdDrawer.open = !this.mdDrawer.open;
        });
    }

    toggleMenu() {
        this.mdDrawer.open = !this.mdDrawer.open;
    }

    render() {
        return (
            <div>
                <aside className="rese-drawer mdc-drawer mdc-drawer--modal" dir="rtl" ref={this.mdDrawerRef}>
                    <IconButton classNames="menu-close-icon" icon={{ className:"fas fa-times"}} tooltip="Close" onClick={this.toggleMenuClick}/>
                    <div className="mdc-drawer__content">
                        <nav className="mdc-list">
                            {this.props.children}
                        </nav>
                    </div>
                </aside>
                <div className="mdc-drawer-scrim"></div>
            </div>
        );
    }
}
SideMenu.propTypes = {
    mainContentId: PT.string,
    appBarId: PT.string,
    menuItems: PT.array
};

export function SideMenuTitle(props) {
    return <h2>{props.children}</h2>;
}
SideMenuTitle.propTypes = { children: PT.string };

export function SideMenuSubTitle(props) {
    return <h3>{props.children}</h3>;
}
SideMenuSubTitle.propTypes = { children: PT.string };


export function SideMenuSection(props) {
    return <div className="section">
        <SideMenuTitle>{props.title}</SideMenuTitle>
        {props.children}
        <div className="spacer-row"></div>
    </div>;
}
SideMenuSection.propTypes = {
    title: PT.string,
    children: PT.any
};

export function SideMenuSubSection(props) {
    return <div className="sub-section">
        <SideMenuSubTitle>{props.title}</SideMenuSubTitle>
        {props.children}
    </div>;
}
SideMenuSubSection.propTypes = {
    title: PT.string,
    children: PT.any
};


export function SideMenuLinkItem(props) {
    return <a href={props.url} className={cIf(["rese-list-item", "mdc-list-item", {"mdc-list-item--activated": props.selected }])}>{props.children}</a>;
}
SideMenuLinkItem.propTypes = { children: PT.string, url: PT.string, selected: PT.bool };
SideMenuLinkItem.defaultProps = { selected: false };

export function SideMenuTextItem(props) {
    return <div className={cIf(["rese-list-item", "mdc-list-item",  {"mdc-list-item--activated": props.selected, "menu-item-ltr": props.isLtr}])}>
        <span className="mdc-list-item__text">{props.children}</span>
    </div>;
}
SideMenuTextItem.propTypes = { children: PT.string, selected: PT.bool, isLtr: PT.bool };
SideMenuTextItem.defaultProps = { selected: false, isLtr: false };

export function SideMenuSpacer() {
    return <div className="spacer-row"></div>;
}



